// src/onboarding/stepBuilder.ts
import type { OnboardingStepDeps } from '@/composables/useOnboarding';
import type { StepOptions } from 'shepherd.js';

// Importez tous les chapitres
import { getIntroductionSteps } from './chapters/01_Introduction';
import { getRecipeGenerationSteps } from './chapters/02_RecipeGeneration';
import { getRecipeDetailsSteps } from './chapters/03_RecipeDetails';
import { getRecipeActionsSteps } from './chapters/04_RecipeActions';
import { getOrganizationSteps } from './chapters/05_Organization';
import { getScanSteps } from './chapters/06_Scan';
import { getProfileAndTeamSteps } from './chapters/07_ProfileAndTeam';
import { getPlanningSteps } from './chapters/08_Planning';
import { getEndSteps } from './chapters/09_End';

import { getTransitionSteps } from './transitionSteps';
export function buildAllSteps(deps: OnboardingStepDeps): StepOptions[] {
  const transitions = getTransitionSteps(deps);

  return [
    ...getIntroductionSteps(deps),
    transitions[0], // transition-1-2

    ...getRecipeGenerationSteps(deps),
    transitions[1], // transition-2-3

    ...getRecipeDetailsSteps(deps),
    transitions[2], // transition-3-4

    ...getRecipeActionsSteps(deps),
    transitions[3], // transition-4-5

    ...getOrganizationSteps(deps),
    transitions[4], // transition-5-6

    ...getScanSteps(deps),
    transitions[5], // transition-6-7

    ...getProfileAndTeamSteps(deps),
    transitions[6], // transition-7-8

    ...getPlanningSteps(deps),
    transitions[7], // transition-8-9

    ...getEndSteps(deps),
  ];
}
